import React from 'react';
import { Box, Text, ResponsiveContext } from 'grommet';

import { getPercent } from '../../utils';
import { formattedNumber } from '../../../../utils';

function CardService({ status, color, total, services }) {
  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          round='small'
          width={ size === 'small' ? 'large' : 'medium' }
          pad={{
            vertical: size === 'small' ? 'large' : 'medium',
            horizontal: size === 'small' ? 'large' : 'medium',
          }}
          border={{ color: 'light-4' }}
        >
          <Box
            direction='row'
            justify='between'
            align='center'
            gap='small'
          >
            <Text truncate title={status} size='small'>{status}</Text>
            <Box background={{ color }} width='20px' height='10px' round='medium' />
          </Box>

          <Box
            direction='row'
            justify='between'
            align='end'
            margin={{ top: 'small' }}
            gap='small'
          >
            <Text color='brand' size='large'>{formattedNumber(total)}</Text>
            <Text color='dark-4' size='small'>{getPercent(services, total)}</Text>
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
}

export default CardService;
